export default __webpack_public_path__ + "static/media/section-3-img1.4fc43362.png";